import { combineReducers } from "redux";

import potlucks from './potlucks';

export default combineReducers({
    potlucks,
});